import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _taggedTemplateLiteral from "/usr/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _templateObject, _templateObject2;
var _excluded = ["className", "classNames", "showOutsideDays", "captionLayout", "buttonVariant", "locale", "dir", "formatters", "components"],
  _excluded2 = ["className", "rootRef"],
  _excluded3 = ["className", "orientation"],
  _excluded4 = ["children"],
  _excluded5 = ["className", "day", "modifiers"];
var __jsx = React.createElement;
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import { cn } from "@/common/lib/utils";
import { CalendarButton, buttonVariants } from "./CalendarButton";
import * as React from "react";
import { Icon } from "@syarahtech/ui";
function Calendar(_ref) {
  var className = _ref.className,
    classNames = _ref.classNames,
    _ref$showOutsideDays = _ref.showOutsideDays,
    showOutsideDays = _ref$showOutsideDays === void 0 ? true : _ref$showOutsideDays,
    _ref$captionLayout = _ref.captionLayout,
    captionLayout = _ref$captionLayout === void 0 ? "label" : _ref$captionLayout,
    _ref$buttonVariant = _ref.buttonVariant,
    buttonVariant = _ref$buttonVariant === void 0 ? "primary" : _ref$buttonVariant,
    locale = _ref.locale,
    _ref$dir = _ref.dir,
    dir = _ref$dir === void 0 ? "rtl" : _ref$dir,
    formatters = _ref.formatters,
    components = _ref.components,
    props = _objectWithoutProperties(_ref, _excluded);
  var defaultClassNames = getDefaultClassNames();
  return /*#__PURE__*/React.createElement(DayPicker, _extends({
    showOutsideDays: showOutsideDays,
    locale: locale,
    dir: dir,
    className: cn("bg-background group/calendar p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent !min-h-[300px]", String.raw(_templateObject || (_templateObject = _taggedTemplateLiteral(["rtl:**:[.rdp-button_next>svg]:rotate-180"], ["rtl:**:[.rdp-button\\_next>svg]:rotate-180"]))), String.raw(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["rtl:**:[.rdp-button_previous>svg]:rotate-180"], ["rtl:**:[.rdp-button\\_previous>svg]:rotate-180"]))), className),
    captionLayout: captionLayout,
    formatters: _objectSpread({
      formatMonthDropdown: function formatMonthDropdown(date) {
        return date.toLocaleString("default", {
          month: "short"
        });
      }
    }, formatters),
    classNames: _objectSpread({
      root: cn("w-fit", defaultClassNames.root),
      months: cn("flex gap-4 flex-col md:flex-row relative", defaultClassNames.months),
      month: cn("flex flex-col w-full gap-8", defaultClassNames.month),
      nav: cn("flex items-center gap-1 w-full absolute top-0 inset-x-0 justify-between", defaultClassNames.nav),
      button_previous: cn(buttonVariants(buttonVariant), "size-(--cell-size) aria-disabled:opacity-50 p-2 select-none en:transform en:rotate-180", defaultClassNames.button_previous),
      button_next: cn(buttonVariants(buttonVariant), "size-(--cell-size) aria-disabled:opacity-50 p-2 select-none en:transform en:rotate-180", defaultClassNames.button_next),
      month_caption: cn("flex items-center justify-center h-(--cell-size) w-full px-(--cell-size) pt-2 text-primary-new font-semibold [&>span]:text-base", defaultClassNames.month_caption),
      dropdowns: cn("w-full flex items-center text-sm font-medium justify-center h-(--cell-size) gap-1.5", defaultClassNames.dropdowns),
      dropdown_root: cn("relative has-focus:border-ring border border-input shadow-xs has-focus:ring-ring/50 has-focus:ring-[3px] rounded-md", defaultClassNames.dropdown_root),
      dropdown: cn("absolute bg-popover inset-0 opacity-0", defaultClassNames.dropdown),
      caption_label: cn("select-none font-medium", captionLayout === "label" ? "text-sm" : "rounded-md pl-2 pr-1 flex items-center gap-1 text-sm h-8 [&>svg]:text-muted-foreground [&>svg]:size-3.5", defaultClassNames.caption_label),
      weeks: "grid grid-cols-7 grid-rows-5 md:flex md:justify-between md:flex-wrap",
      weekdays: cn("grid grid-cols-7 text-center md:flex md:justify-between", defaultClassNames.weekdays),
      weekday: cn("text-xs select-none text-[#00143C] font-medium flex items-center justify-center md:w-10 md:h-10", defaultClassNames.weekday),
      week: cn("contents md:flex md:w-full md:justify-between", defaultClassNames.week),
      week_number_header: cn("select-none w-(--cell-size)", defaultClassNames.week_number_header),
      week_number: cn("text-xs select-none text-[#00143C] font-medium", defaultClassNames.week_number),
      day: cn("relative w-full h-full max-w-10 max-h-10 p-0 text-center rounded-full group/day aspect-square select-none flex items-center justify-center text-base [&:not([data-today=true]):not([data-disabled=true])]:text-primary-new [&[data-today=true]]:!text-[#12B0FF] [&data-[selected-single]] md:w-10 md:h-10", props.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-md" : "[&:first-child[data-selected=true]_button]:rounded-l-md", defaultClassNames.day),
      range_start: cn("rounded-l-md bg-accent", defaultClassNames.range_start),
      range_middle: cn("rounded-none", defaultClassNames.range_middle),
      range_end: cn("rounded-r-md bg-accent", defaultClassNames.range_end),
      today: cn("!text-[#12B0FF] bg-[#F1F6FC] rounded-full data-[selected=true]:rounded-full transition-colors ease-in", defaultClassNames.today),
      outside: cn("text-muted-foreground aria-selected:text-muted-foreground", defaultClassNames.outside),
      disabled: cn("text-[#B0B0B0]", defaultClassNames.disabled),
      chevron: cn("bg-gray-text", classNames),
      hidden: cn("invisible", defaultClassNames.hidden)
    }, classNames),
    components: _objectSpread({
      Root: function Root(_ref2) {
        var className = _ref2.className,
          rootRef = _ref2.rootRef,
          props = _objectWithoutProperties(_ref2, _excluded2);
        return /*#__PURE__*/React.createElement("div", _extends({
          "data-slot": "calendar",
          ref: rootRef,
          className: cn(className)
        }, props));
      },
      Chevron: function Chevron(_ref3) {
        var className = _ref3.className,
          orientation = _ref3.orientation,
          props = _objectWithoutProperties(_ref3, _excluded3);
        if (orientation === "left") {
          return /*#__PURE__*/React.createElement(Icon, _extends({
            icon: "material-symbols--arrow-forward-ios-rounded",
            width: 5,
            height: 5,
            className: cn(className)
          }, props));
        }
        if (orientation === "right") {
          return /*#__PURE__*/React.createElement(Icon, _extends({
            icon: "material-symbols--arrow-back-ios-new-rounded",
            width: 5,
            height: 5,
            className: cn(className)
          }, props));
        }
        return /*#__PURE__*/React.createElement(Icon, _extends({
          icon: "material-symbols--keyboard-arrow-down-rounded",
          width: 4,
          height: 4,
          className: cn(className)
        }, props));
      },
      DayButton: CalendarDayButton,
      WeekNumber: function WeekNumber(_ref4) {
        var children = _ref4.children,
          props = _objectWithoutProperties(_ref4, _excluded4);
        return /*#__PURE__*/React.createElement("td", props, /*#__PURE__*/React.createElement("div", {
          className: "flex size-(--cell-size) items-center justify-center text-center"
        }, children));
      }
    }, components)
  }, props));
}
function CalendarDayButton(_ref5) {
  var className = _ref5.className,
    day = _ref5.day,
    modifiers = _ref5.modifiers,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var defaultClassNames = getDefaultClassNames();
  var ref = React.useRef(null);
  React.useEffect(function () {
    var _ref$current;
    if (modifiers.focused) (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
  }, [modifiers.focused]);
  return /*#__PURE__*/React.createElement(CalendarButton, _extends({
    ref: ref,
    variant: "ghost",
    size: "icon",
    "data-day": day.date.toLocaleDateString(),
    "data-today": modifiers.today,
    "data-selected-single": modifiers.selected && !modifiers.range_start && !modifiers.range_end && !modifiers.range_middle,
    "data-range-start": modifiers.range_start,
    "data-range-end": modifiers.range_end,
    "data-range-middle": modifiers.range_middle,
    className: cn("data-[selected-single=true]:bg-primary-new data-[selected-single=true]:text-white data-[selected-single=true]:rounded-full data-[range-middle=true]:bg-primary-new data-[range-middle=true]:text-accent-foreground data-[range-start=true]:bg-primary-new data-[range-start=true]:text-primary-new-foreground data-[range-end=true]:bg-primary-new data-[range-end=true]:text-primary-new-foreground group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-ring/50 dark:hover:text-accent-foreground flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:ring-[3px] data-[range-end=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-md data-[range-start=true]:rounded-l-md [&>span]:text-xs [&>span]:opacity-70 data-[selected-single=true]", defaultClassNames.day, className, "data-[today=true]:!bg-[#F1F6FC] data-[today=true]:!text-[#12B0FF] data-[day]:!rounded-full", "data-[today=true]:data-[selected-single=true]:!bg-primary-new data-[today=true]:data-[selected-single=true]:!text-white")
  }, props));
}
export { Calendar, CalendarDayButton };